// extracted by mini-css-extract-plugin
export default {"slider-container":"ContinuousSlider_slider-container__VALNT","slick-slide":"ContinuousSlider_slick-slide__XYuZn"};